export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/40"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/30"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-secondary-100/20"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 pt-[72px]">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12 py-12 md:py-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs md:text-sm font-bold mb-4 whitespace-nowrap">
              全网热瓜 · 一手掌握
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-950 leading-tight mb-4">
              51吃瓜网址
              <span className="block text-primary-500 text-lg md:text-2xl lg:text-3xl mt-2 font-bold">
                你的随身吃瓜神器
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-6">
              51吃瓜网址汇聚全网最新娱乐八卦与热点资讯，提供51吃瓜app、51吃瓜轻量版及51吃瓜网app多端下载。
              无论你是安卓用户还是苹果用户，都能在这里找到最适合你的客户端安装包。
              每日更新热点追踪，让你不错过任何一个精彩瓜料，随时随地畅快吃瓜。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>日更新 50+ 热门话题</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                <span>覆盖全网 100+ 信息源</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                <span>千万吃瓜用户信赖</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-bold text-sm md:text-base rounded-lg hover:bg-primary-600 transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-line mr-2"></i>
                立即下载APP
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-100 text-foreground-800 font-medium text-sm md:text-base rounded-lg hover:bg-background-200 transition-colors duration-200 text-center whitespace-nowrap cursor-pointer border border-background-200/60"
              >
                <i className="ri-fire-line mr-2"></i>
                查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20entertainment%20news%20and%20social%20media%20gossip%20theme%2C%20warm%20orange%20and%20coral%20tones%2C%20modern%20flat%20design%20with%20abstract%20shapes%20representing%20news%20bubbles%20and%20trending%20topics%2C%20clean%20minimal%20background%20with%20geometric%20elements%2C%20digital%20media%20aesthetic%2C%20editorial%20illustration%20style&width=700&height=600&seq=hero-main-visual-01&orientation=landscape"
                alt="51吃瓜网址 - 娱乐资讯聚合平台主视觉"
                className="w-full h-auto object-cover rounded-lg"
                width="700"
                height="600"
              />
              <div className="absolute -bottom-3 -right-3 bg-background-50 rounded-lg px-4 py-2 border border-background-200/60">
                <span className="text-xs text-foreground-500">最新版本 v3.2.1</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}